export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}release-note/release-note`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        getChangelogs: {
            method: 'GET',
            url: baseUrl,
            isArray: true
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/ReleaseNote/index.js